// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3684367b","453":"b1de5d48","455":"4cbd6873","977":"59bda7bd"}[chunkId] + ".chunk.js";
};